/**
 * The service worker caches some authenticated GET responses for offline reading.
 * They are dropped on sign-out so the next person on this device can't read them.
 */
export async function clearApiCaches(): Promise<void> {
  if (typeof caches === 'undefined') return;
  const names = await caches.keys();
  await Promise.all(names.filter((n) => n.startsWith('api-')).map((n) => caches.delete(n)));
}
